import React from 'react';
// template components
import Accordion from '@nmx/template/dist/componentLibrary/modules/Accordion';
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import MinusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/MinusSignFill';
import PlusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/PlusSignFill';

export default () => (
  <SectionContainer
    id='college-savings-plans-faq'
    moduleName='faq-module'>
    <Row align='center'>
      <Col
        align='center'
        medium={10}
        large={8}>
        <Typography
          component='h2'
          nextElement='typography'>
          Questions about college savings plan&#63; <WidowBlock>We&#39;ve got answers.</WidowBlock>
        </Typography>
      </Col>
      <Col
        medium={10}
        large={8}>
        <Accordion
          id='faq-college-savings-plans'
          variant='secondary'
          toggleOpenIcon={PlusSignFillIcon}
          toggleCloseIcon={MinusSignFillIcon}
          isFAQ
          items={[
            {
              id: 'college-savings-plans-what-is-it',
              title: <>What&#39;s the most common college <WidowBlock>savings account&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    <Link
                      id='faq-college-savings-plans-529-plans-link'
                      linkUrl='/529-college-savings-plans/'
                      ariaLabel='Learn more about 529 college savings plan'
                      variant='primaryDeemphasize'>
                      529 plans
                    </Link>
                    &nbsp;are by far the most popular way to save for college. These state&#45;sponsored accounts grow on a tax&#45;free basis and allow for tax&#45;free withdraws if used for qualified education expenses.&nbsp;
                    <Link
                      id='faq-college-savings-plans-other-savings-options-link'
                      linkUrl='/life-and-money/savings-plans-for-college-6-options-to-consider/'
                      ariaLabel='Learn about other savings plans to consider for college'
                      variant='primaryDeemphasize'>
                      Check out other savings options
                    </Link>
                    &nbsp;that might be right for you.
                  </Typography>
                </>
              ),
            },
            {
              id: 'college-savings-plans-how-much-to-put-away',
              title: <>How much should I put away in <WidowBlock>college fund&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    Costs will depend on the type of school you&#39;re aiming for&#8212;private or public. First up, decide how much of your child&#39;s education you want to cover. Do you want to pay a percentage&#63; A specific dollar amount&#63; Or maybe all of it&#63; Once you&#39;ve got that settled, you&#39;ll need to figure out which type of savings account (or accounts) will best fit into your overall financial plan. Need help&#63; Our financial advisors are here for you.&nbsp;
                    <Link
                      id='faq-college-savings-plans-get-matched-link'
                      linkUrl='/find-a-financial-advisor/'
                      ariaLabel='Get matched with a financial advisor today'
                      variant='primaryDeemphasize'>
                      Get matched with one today
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: 'college-savings-plans-tax-advantages',
              title: <>What are the tax advantages of college <WidowBlock>savings plans&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    Contributions to college saving plans like a&nbsp;
                    <Link
                      id='faq-college-savings-plans-529-plans-again-link'
                      linkUrl='/529-college-savings-plans/'
                      ariaLabel='Learn more about 529 college savings plan'
                      variant='primaryDeemphasize'>
                      529
                    </Link>
                    &nbsp;and Coverdell account will grow tax&#45;free, and are usually exempt from federal income taxes. Plus, many states offer tax deductions for 529 plans.
                  </Typography>
                </>
              ),
            },
            {
              id: 'college-savings-plans-how-do-they-work',
              title: <>How does a 529 <WidowBlock>plan work&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    Anyone can open a 529 account in their home state, or in any other state. Once you&#39;ve established an account, you&#39;ll choose the type of investment (usually mutual funds) you want to invest in. The money contributed will grow on a tax&#45;deferred basis until it is withdrawn. As long as the money is used for qualified education expenses, it will be tax free.&nbsp;
                    <Link
                      id='faq-college-savings-plans-connect-with-advisor-link'
                      linkUrl='/find-a-financial-advisor/'
                      ariaLabel='Connect with an advisor to discuss how to open a 529 account.'
                      variant='primaryDeemphasize'>
                      Connect with an advisor
                    </Link>
                    &nbsp;to see if a 529 plan is right for your education funding goals.
                  </Typography>
                </>
              ),
            },
            {
              id: 'college-savings-plans-who-can-set-up-a-plan',
              title: <>Who can open a 529 plan or <WidowBlock>Coverdell ESA&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    Anyone who lives in the United States and is aged 18 and over can open a 529 or Coverdell account. And anyone can contribute money to help pay for a child&#39;s education&#8212;parents, grandparents, aunts, uncles, cousins, even friends.&nbsp;
                    <Link
                      id='faq-college-savings-plans-how-to-set-up-529-link'
                      linkUrl='/life-and-money/how-to-open-529-plan/'
                      ariaLabel='How to set up a 529 plan'
                      variant='primaryDeemphasize'>
                      Find out more on how to set up your 529 plan
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: 'college-savings-plans-do-i-have-to-invest-state-529-plan',
              title: <>Do I have to invest in my own state&#39;s <WidowBlock>529 plan&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    No. You can use a&nbsp;
                    <Link
                      id='faq-college-savings-plans-529-plans-again-link'
                      linkUrl='/529-college-savings-plans/'
                      ariaLabel='Learn more about 529 college savings plan'
                      variant='primaryDeemphasize'>
                      529 plan
                    </Link>
                    &nbsp;from any state to pay for qualified expenses in any other state. So, you can use funds from a 529 plan in Oregon to pay for college in New York. From a tax perspective, there could be tax deductions or credits that you can take advantage of based on contributions to a particular state&#39;s 529 plan. Ask a financial advisor which 529 plan is best for you,&nbsp;
                    <Link
                      id='faq-college-savings-plans-get-matched-again-link'
                      linkUrl='/find-a-financial-advisor/'
                      ariaLabel='Connect with an advisor to discuss disability insurance costs.'
                      variant='primaryDeemphasize'>
                      get matched with one today
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: 'college-savings-plans-what-happens-if-i-dont-use-529-plan',
              title: <>What happens if I don&#39;t use my <WidowBlock>529 plan&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography nextElement='typography'>
                    The good thing is there are no deadlines to use the money you&#39;ve accumulated, so you have time to weigh your options. Here&#39;s what you consider:
                  </Typography>
                  <BulletedList
                    bulletedListData={[
                      { bulletText: 'Change the beneficiary to another family member including yourself.' },
                      { bulletText: <>Use the remaining money to repay up to &#36;10K of student loans.</> },
                      { bulletText: <>Cash it out (a non&#45;qualified withdrawal could trigger penalties and taxes).</> },
                    ]}
                    bulletType='filledCircle' />
                  <Typography disableBottomPadding>
                    Talk to an advisor about which option might be right for you.&nbsp;
                    <Link
                      id='faq-college-savings-plans-talk-to-advisor-link'
                      linkUrl='/find-a-financial-advisor/'
                      ariaLabel='Get matched with a financial advisor today'
                      variant='primaryDeemphasize'>
                      Get matched today.
                    </Link>
                  </Typography>
                </>
              ),
            },
          ]}
        />
      </Col>
    </Row>
  </SectionContainer>
);
